import { createSlice } from "@reduxjs/toolkit";

export const alertSlice = createSlice({
  name: "alert",
  initialState: { open: false, message: "", severity: "info" },
  reducers: {
    notifyShowSuccessMessage: (state, action) => {
      state.message = action.payload;
      state.severity = "success";
      state.open = true;
    },
    notifyShowErrorMessage: (state, action) => {
      state.message = action.payload;
      state.severity = "error";
      state.open = true;
    },
    notifyShowInfoMessage: (state, action) => {
      state.message = action.payload;
      state.severity = "info";
      state.open = true;
    },
    closeNotificationMessage: (state, action) => {
      state.open = false;
      state.message = "";
      state.severity = "info";
    },
  },
});

export const {
  notifyShowSuccessMessage,
  notifyShowErrorMessage,
  notifyShowInfoMessage,
  closeNotificationMessage,
} = alertSlice.actions;
export default alertSlice.reducer;
